import { render, staticRenderFns } from "./1-member-profile-extras.vue?vue&type=template&id=6e4b6105&scoped=true"
import script from "./1-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./1-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./1-member-profile-extras.vue?vue&type=style&index=0&id=6e4b6105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b6105",
  null
  
)

export default component.exports